import React, { useEffect, useState } from "react";
import Dashboard from "../../../layouts/Dashboard";
import { Card, Modal, Input, Select } from "antd";
import "../forms/Html/formsStyle.css";
import axios from "axios";
import BASE from "../../../config";
import ReactLoading from "react-loading";
import Thumbnial from "../../../images/file_thumbnail.png";
import { formatDateDDMMYYYY } from "../../../utils/commonFunctions";
import url from "../../../services/url";
import JSZip from "jszip";
import { LOGOS } from "../../../utils/companyLogosObj";
import useAxios from "../../../hooks/useAxios";
import LightGallery from "lightgallery/react";

import "lightgallery/css/lightgallery.css";
import "lightgallery/css/lg-zoom.css";
import "lightgallery/css/lg-thumbnail.css";
import "lightgallery/css/lg-video.css";

import lgThumbnail from "lightgallery/plugins/thumbnail";
import lgZoom from "lightgallery/plugins/zoom";
import lgVideo from "lightgallery/plugins/video";
import useGetFile from "../../../hooks/useGetFile";
import { useParams } from "react-router-dom/cjs/react-router-dom";

const { Option } = Select;
const { Search } = Input;

function ViewDoc() {
  const videoExt = ["mp4"];
  const docExt = ["pdf", "doc"];
  const imgExt = ["png", "jpeg", "jpg"];
  const zip = new JSZip();
  const { getImage } = useGetFile(localStorage.getItem("user.token"))
  const domParser = new DOMParser();
  const [load, setLoad] = useState(false);
  const [open, setOpen] = useState(false);
  const [htmlData, setHtmlData] = useState(null);
  const [openForm, setOpenForm] = useState(false);
  const [openedDoc, setOpenedDoc] = useState(null);
  const [src, setSrc] = useState([]);
  const [empId, setEmpId] = useState("");
  const [documentType, setDocumentType] = useState("Local");
  const [documents, setDocuments] = useState("");
  const [businessType, setBusinessType] = useState("");
  const [candidateDetails, setCandidateDetails] = useState();
  const api = useAxios();
  const onSearch = async (value, event) => {
    console.log(event);
    if (!value) return;
    setEmpId(value);
    getDocuments(value);
  };

  const { id } = useParams();

  const caseConversion = (string) => {
    return string?.replace(/([A-Z])/g, " $1").replace(/^./, function (str) {
      return str?.toUpperCase();
    });
  };



  const getDocuments = async (id) => {
    const config = {
      url: BASE.api + `/candidateDocuments/AllCandidateDocuments/${id}`,
      method: "get",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("user.token")}`,
      },
    };
    setLoad(true);
    try {
      const result = await axios(config);
      setLoad(false);
      getCandidateDetails(result.data.personalDetails[0]._id);
      setDocuments(result.data);
      const {
        bankDetails,
        candidateDocuments,
        personalDetails,
        companyDocuments,
      } = result.data;
      let srces = [];
      const {
        aadharCardImage,
        candidatePhoto,
        candidateSignature,
        panCardImage,
        _id
      } = personalDetails[0];

      const config1 = {
        url: BASE.api + `/candidates/${_id}`,
        method: "get",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("user.token")}`,
        },
      };
      const candidate = await axios(config1);
      const {files} = candidate.data

      srces.push({ path: aadharCardImage[0].path, type: "img" , name : caseConversion(aadharCardImage[0]?.fieldname),personalDetails : 'personalDetails',_id : candidate.data._id});
      srces.push({ path: candidatePhoto[0].path, type: "img" , name : caseConversion(candidatePhoto[0]?.fieldname),personalDetails : 'personalDetails',_id : candidate.data._id});
      srces.push({ path: candidateSignature[0].path, type: "img" , name : caseConversion(candidateSignature[0]?.fieldname),personalDetails : 'personalDetails',_id : candidate.data._id});
      srces.push({ path: panCardImage[0].path, type: "img" , name : caseConversion(panCardImage[0]?.fieldname),personalDetails : 'personalDetails',_id : candidate.data._id});

      bankDetails[0].files.forEach((ele) => {
        srces.push({ path: ele.path, type: "img",name : ele?.fieldname,bankDetails : 'bankDetails' });
      });
      candidateDocuments[0].files.forEach((ele) => {
        srces.push({ path: ele.path, type: "img" , name : ele?.fieldname,candidateDocuments : 'candidateDocuments'});
      });
      for(let i = 0 ; i < files.length ; i++){
        if(files[i].originalname?.split('.')?.pop()?.toLowerCase() === 'mp4'){
          const file = await getImage(files[i].path)
          srces.push({ path: file, type: "mp4", name : files[i]?.fieldname });
        }
      }
      setSrc(srces);
    } catch (err) {
      console.error(err);
      setLoad(false);
    }
  };


  useEffect(() => {
    getDocuments(id)
  },[id])

  const showDoc = async (e, doc) => {
    if (!doc.originalname) {
      doc.originalname = "file_name.pdf";
    }
    setOpenedDoc(doc);
    setOpen(true);
  };

  const getCandidateDetails = async (_id) => {
    setLoad(true);
    const config = {
      url: BASE.api + `/candidates/${_id}`,
      method: "get",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("user.token")}`,
      },
    };
    try {
      const result = await axios(config);
      console.log(result);
      setBusinessType(
        result?.trf?.businessType
      );
      setDocumentType(result.data.documentType);
      setCandidateDetails(result.data);
      setLoad(false);
    } catch (err) {
      setLoad(false);
      console.log(err);
    }
  };

  const downloadDoc = async (e, doc) => {
    try {
      setLoad(true);
      const res = await fetch(doc.filePath, {
        mode: "cors",
      });
      const blob = await res.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `${doc?.companyDocumentId?.formName}` || "file";
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
      setLoad(false);
    } catch (err) {
      console.log(err);
      setLoad(false);
    }
  };

  const downloadAsZip = async (e, _data, key) => {
    setLoad(true);
    try {
      for (let i = 0; i < _data.length; i++) {
        if (key === "companyDocuments") {
          console.log(_data[i]);
          try {
            const res = await fetch(_data[i].filePath, {
              mode: "cors",
            });
            const blob = await res.blob();
            zip.file(`${_data[i].companyDocumentId.formName}.pdf`, blob);
          } catch (err) {
            console.log(err);
          }
        } else {
          let key = Object.keys(_data[i]);
          for (let j = 0; j < key.length; j++) {
            if (Array.isArray(_data[i][key[j]])) {
              for (let k = 0; k < _data[i][key[j]].length; k++) {
                try {
                  const res = await fetch(_data[i][key[j]][k].path, {
                    mode: "cors",
                  });
                  const blob = await res.blob();
                  let ext = _data[i][key[j]][k].originalname.split(".").pop();
                  zip.file(`${_data[i][key[j]][k].originalname}.${ext}`, blob);
                } catch (err) {
                  console.log(err);
                }
              }
            }
          }
        }
      }
      const zipFile = await zip.generateAsync({ type: "blob" });
      const blobUrl = URL.createObjectURL(zipFile);
      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = `${key}.zip`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(blobUrl);
      setLoad(false);
    } catch (err) {
      console.log(err);
      setLoad(false);
    }
  };

  const onInit = () => {
    console.log("lightGallery has been initialized");
  };

  return (
    <Dashboard title="Digital Document">
      {load && (
        <ReactLoading type="spin" color="#0000FF" className="spinnerBg" />
      )}
      <div className="row">
        {/* <div className="col-md-12">
          <Card title="" className="border mt-1">
            <div className="row">
              <div className="col-md-12">
                <div className="mb-2 bg-white cursor-pointer">
                  <Search
                    placeholder="Enter EMP ID..."
                    onSearch={onSearch}
                    style={{
                      width: 300,
                    }}
                    onChange={(e) => {
                      setEmpId(e.target.value);
                    }}
                  />
                </div>
              </div>
              <div className="col-md-6">
                    <div>
                    <label htmlFor="">Select Location</label>
                        <Select
                            id="city"
                            showSearch
                            style={{ width: "100%", height: "37px" }}
                            placeholder="Select Business Type"
                            optionFilterProp="children"
                            filterOption={(input, option) => {
                            return (
                                option?.children
                                ?.toLowerCase()
                                .indexOf(input.toLowerCase()) >= 0 ||
                                option.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            );
                            }}
                            // onChange={(value) => setBusinessType(value)}
                            >
                            <Option value={"All"}>All</Option>
                            {businessTypeList?.map((business) => (
                            <Option value={business?.businessType}>
                                {business?.businessType}
                            </Option>
                            ))}
                        </Select>
                    </div>
                </div>
            </div>
          </Card>
        </div> */}
        {documents && candidateDetails && (
          <div className="col-md-12">
            <Card title="Documents" className="border mt-1">
              <div className="row">
                <div className="col-12" style={{ width: "100%" }}>
                  <LightGallery
                    onInit={onInit}
                    speed={500}
                    plugins={[lgThumbnail, lgZoom, lgVideo]}
                    zoomFromOrigin={true}
                  >
                    {src.map((src) => {
                      if (src.type === "img") {
                        return (
                            <a 
                              style={{border:'1px solid #fff',width:'100%',display:'block',position:'relative',marginBottom : '5px'}} 
                              href={src.path}
                              data-sub-html={src.name}
                            >
                              <img alt="img1" src={src.path} />
                            </a>
                        );
                      } else if(src.type === 'mp4') {
                        return (
                          <a
                            data-lg-size="1280-720"
                            data-video={'{"source": [{"src":"' + src.path + '", "type":"video/mp4"}], "attributes": {"preload": false, "controls": true}}'}
                            data-poster="/img/thubnail.jpg"
                            data-sub-html={src.name}
                          >
                            <img class="img-responsive" src="/img/thubnail.jpg" />
                          </a>
                        )
                      }
                    })}
                  </LightGallery>
                </div>
                {Object.keys(documents).map((key) => {
                  let data = [...documents[key]];
                  if (data.length !== 0) {
                    return (
                      <div className="col-12 mb-4">
                        <div className="row">
                          {key === "companyDocuments" && (
                            <div className="col-12 d-flex mb-3 gap-2 align-items-center justify-content-between">
                              <h5 style={{ marginBottom: 0 }}>
                                {caseConversion(key)}
                              </h5>
                              <button
                                className={`btn-sm btn-primary`}
                                type="submit"
                                onClick={(e) => downloadAsZip(e, data, key)}
                              >
                                Download Zip <i class="fa fa-download"></i>
                              </button>
                            </div>
                          )}
                          <div className="col-12">
                            <div className="row">
                              {key === "companyDocuments" ? (
                                <>
                                  {data.map((doc) => {
                                    return (
                                      <div className="col-md-3 mb-4">
                                        <div
                                          className="border shadow-sm overlay p-2 mx-1 row d-flex align-items-center justify-content-center"
                                          style={{
                                            height: "170px",
                                            position: "relative",
                                          }}
                                        >
                                          <div className="w-100 text-center">
                                            {doc.companyDocumentId.formName}
                                          </div>
                                          <div className="col-md-6 d-flex align-items-center justify-content-center">
                                            <img
                                              style={{
                                                width: "80%",
                                                height: "80%",
                                                objectFit: "contain",
                                              }}
                                              src={Thumbnial}
                                            />
                                          </div>
                                          <div className="col-md-6 d-flex align-items-center justify-content-center">
                                            <button
                                              className={`btn-sm btn-primary`}
                                              type="submit"
                                              onClick={(e) => showDoc(e, doc)}
                                            >
                                              <i class="fa fa-eye"></i>
                                            </button>
                                            <button
                                              className={`btn-sm btn-primary`}
                                              type="submit"
                                              onClick={(e) =>
                                                downloadDoc(e, doc)
                                              }
                                            >
                                              <i class="fa fa-download"></i>
                                            </button>
                                          </div>
                                        </div>
                                      </div>
                                    );
                                  })}
                                </>
                              ) : (
                                <>
                                  {/* {key === "personalDetails" ? (
                                    <>
                                      {data.map((doc) => {
                                        return (
                                          <>
                                            {Object.keys(doc).map((file) => {
                                              if (Array.isArray(doc[file])) {
                                                return (
                                                  <>
                                                    {doc[file].map((data) => {
                                                      return (
                                                        <div className="col-md-3 ">
                                                          <div
                                                            className="border shadow-sm overlay p-2 mx-1  row d-flex align-items-center justify-content-center"
                                                            style={{
                                                              height: "170px",

                                                              position:
                                                                "relative",
                                                            }}
                                                          >
                                                            <div className="w-100 text-center">
                                                              {caseConversion(
                                                                data.fieldname
                                                              )
                                                                ?.replace(
                                                                  /_/g,
                                                                  " "
                                                                )
                                                                ?.replace(
                                                                  /\.png$/,
                                                                  ""
                                                                )
                                                                ?.replace(
                                                                  /(Upload|Image)/g,
                                                                  ""
                                                                )
                                                                .trim()}
                                                            </div>
                                                            <div className="col-md-6 d-flex align-items-center justify-content-center">
                                                              <img
                                                                style={{
                                                                  width: "80%",
                                                                  height: "80%",
                                                                  objectFit:
                                                                    "contain",
                                                                }}
                                                                src={Thumbnial}
                                                              />
                                                            </div>
                                                            <div className="col-md-6 d-flex align-items-center justify-content-center">
                                                              <button
                                                                className={`btn-sm btn-primary`}
                                                                type="submit"
                                                                onClick={(e) =>
                                                                  showDoc(
                                                                    e,
                                                                    data
                                                                  )
                                                                }
                                                              >
                                                                <i class="fa fa-eye"></i>
                                                              </button>
                                                              <a
                                                                className={`btn-sm btn-primary`}
                                                                style={{
                                                                  color:
                                                                    "white",
                                                                }}
                                                                download={`${
                                                                  data.fieldname
                                                                }.${data.originalname
                                                                  ?.split(".")
                                                                  .pop()}`}
                                                                href={data.path}
                                                              >
                                                                <i class="fa fa-download"></i>
                                                              </a>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      );
                                                    })}
                                                  </>
                                                );
                                              }
                                            })}
                                          </>
                                        );
                                      })}
                                    </>
                                  ) : (
                                    <>
                                      {data.map((doc) => {
                                        return (
                                          <>
                                            {doc.files.map((data) => {
                                              return (
                                                <div className="col-md-3 ">
                                                  <div
                                                    className="border shadow-sm overlay p-2 mx-1  row d-flex align-items-center justify-content-center"
                                                    style={{
                                                      height: "170px",

                                                      position: "relative",
                                                    }}
                                                  >
                                                    <div className="w-100 text-center">
                                                      {caseConversion(
                                                        data.fieldname
                                                      )
                                                        ?.replace(/_/g, " ")
                                                        ?.replace(/\.png$/, "")
                                                        ?.replace(
                                                          /(Upload|Image)/g,
                                                          ""
                                                        )
                                                        .trim()}
                                                    </div>
                                                    <div className="col-md-6 d-flex align-items-center justify-content-center">
                                                      <img
                                                        style={{
                                                          width: "80%",
                                                          height: "80%",
                                                          objectFit: "contain",
                                                        }}
                                                        src={Thumbnial}
                                                      />
                                                    </div>
                                                    <div className="col-md-6 d-flex align-items-center justify-content-center">
                                                      <button
                                                        className={`btn-sm btn-primary`}
                                                        type="submit"
                                                        onClick={(e) =>
                                                          showDoc(e, data)
                                                        }
                                                      >
                                                        <i class="fa fa-eye"></i>
                                                      </button>
                                                      <a
                                                        className={`btn-sm btn-primary`}
                                                        style={{
                                                          color: "white",
                                                        }}
                                                        download={`${
                                                          data.fieldname
                                                        }.${data.originalname
                                                          ?.split(".")
                                                          .pop()}`}
                                                        href={data.path}
                                                      >
                                                        <i class="fa fa-download"></i>
                                                      </a>
                                                    </div>
                                                  </div>
                                                </div>
                                              );
                                            })}
                                          </>
                                        );
                                      })}
                                    </>
                                  )} */}
                                </>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  }
                })}
              </div>
            </Card>
          </div>
        )}
      </div>
      <Modal
        centered
        open={open}
        onOk={() => {
          setOpen(false);
          setOpenedDoc(null);
        }}
        onCancel={() => {
          setOpen(false);
          setOpenedDoc(null);
        }}
        footer={false}
        width={800}
      >
        <div>
          <div className="col-md-12">
            <Card title="" className="border mt-3">
              {videoExt.includes(
                openedDoc?.originalname.split(".").pop().toLowerCase()
              ) && (
                <video width="100%" height="300" controls>
                  <source src={openedDoc?.path} />
                </video>
              )}
              {docExt.includes(
                openedDoc?.originalname.split(".").pop().toLowerCase()
              ) && (
                <iframe
                  style={{ width: "100%" }}
                  title="iframe"
                  className="iframe"
                  width="100%"
                  height="400"
                  src={openedDoc?.path || openedDoc?.filePath}
                >
                  <p>iframes are not supported by your browser.</p>
                </iframe>
              )}
              {imgExt.includes(
                openedDoc?.originalname.split(".").pop().toLowerCase()
              ) && (
                <div
                  style={{ width: "200px", height: "400px", margin: "auto" }}
                >
                  <img
                    loading="loading"
                    alt="img"
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "scale-down",
                    }}
                    src={openedDoc?.path}
                  />
                </div>
              )}
            </Card>
          </div>
        </div>
      </Modal>
      <Modal
        centered
        open={openForm}
        onOk={() => {
          setOpenedDoc(null);
          setOpenForm(false);
        }}
        onCancel={() => {
          setOpenedDoc(null);
          setOpenForm(false);
        }}
        footer={false}
        width={1000}
      >
        <div className="col-md-12">
          <Card title="" className="border mt-3">
            <div className="media__print" id="preview"></div>
          </Card>
        </div>
      </Modal>
    </Dashboard>
  );
}

export default ViewDoc;
